// language.service.ts
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@uw-env/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { CustomNavigationService } from './custom-navigation.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private selectedLanguage: string = 'en'; // Default to English

  public showLanguageSwitcher$ = new BehaviorSubject(true);

  public readonly switchLanguage$ = new Subject<string>();

  constructor(private translateService: TranslateService, private customNavService: CustomNavigationService){

    this.switchLanguage$.subscribe(
      lang => {
        localStorage.setItem('lang', lang);
        this.translateService.use(lang);

        const currentPath = window.location.pathname;
        const newPath = lang === 'fr'
          ? this.customNavService.replaceSubUrlToFrenchRoute(currentPath)
          : this.customNavService.replaceSubUrlToEnglishRoute(currentPath);

        if (newPath !== currentPath) {
          window.location.assign(window.location.origin + newPath);
        } else {
          window.location.reload();
        }
      }
    );

  }


  getDefaultRoute(currentURL: string): string {
    this.selectedLanguage = this.translateService.currentLang;

    // the localstorage check here is added for scenario to correctly
    // set login sub url based on lang if the user is on login page and tries to change the
    // language using the language switch provided on the login page.
    if (this.isFrenchURL()) {
    //  this.translateService.use('fr');
    //  this.translateService.currentLang = 'fr';
      // if (!localStorage.getItem('lang') || localStorage.getItem('lang') == 'fr') {
      if (localStorage.getItem('lang') == 'fr') {
        localStorage.setItem('lang', 'fr');
        this.selectedLanguage= 'fr';
      } else {
        this.selectedLanguage= 'en';
      } 
     
    } else {
     // this.translateService.use('en');
     // this.translateService.currentLang = 'en';
     // localStorage.setItem('lang', 'en');

     if (localStorage.getItem('lang') == 'fr') {
        localStorage.setItem('lang', 'fr');
        this.selectedLanguage= 'fr';
      } else {
      this.selectedLanguage= 'en';
      } 
    }

    let defaultRoute;

    if (currentURL.includes('sso-login') || currentURL.includes('sso-connexion')) {
      defaultRoute = this.selectedLanguage == 'fr' ? '/principale/sso-connexion' : '/main/sso-login';
    } else {
      defaultRoute = this.selectedLanguage == 'fr' ? '/principale/connexion' : '/main/login';
    }

    return defaultRoute;
  }

  private isFrenchURL(): boolean {
    const currentURL = window.location.href;
    // Check if the URL contains '/fr/' indicating a French URL
    return currentURL.includes(environment.frenchUrl);
  }
}
